import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { InlineInputGroup, TimePicker } from 'barnyard/components';


const InlineTimeSelect = (props) => {
  const {
    label,
    description,
    ...other
  } = props;

  return (
    <InlineInputGroup
      label={label}
      description={description}
      InputComponent={TimePicker}
      {...other}
    />
  );
};

InlineTimeSelect.propTypes = {
  label: PropTypes.string,
  description: PropTypes.string,
};

InlineTimeSelect.defaultProps = {
  label: 'Time',
  description: 'The local time that should be adhered to by a location.'
};

export default memo(InlineTimeSelect);
